import React from 'react';
import fr from 'facet-rest';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDPaper, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';

export const accountOpeningAgreementErrorMetaOverrideSet = buildBaseOverrides()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);

export const AccountOpeningAgreementError = () => {
  const { resource } = useMetaLayoutContext();
  const fixButton = resource.withRelationship(
    fr.relationships.fixLink.name,
    (rel) => (
      <PrimaryActionButtonRel
        relationship={rel}
        {...dataAttrs('fix-error-btn')}
      />
    ),
    () => null,
  );

  return (
    <FDPaper appearance={'elevated'} padding={4}>
      <FDStack direction={'column'} spacing={2} alignItems={'flex-start'}>
        <MetaControlField attr={'title'} />
        {fixButton}
      </FDStack>
    </FDPaper>
  );
};
